import { render, staticRenderFns } from "./ColumnRemark.vue?vue&type=template&id=548cbad1&scoped=true"
import script from "./ColumnRemark.vue?vue&type=script&lang=ts"
export * from "./ColumnRemark.vue?vue&type=script&lang=ts"
import style0 from "./ColumnRemark.vue?vue&type=style&index=0&id=548cbad1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548cbad1",
  null
  
)

export default component.exports